// extracted by mini-css-extract-plugin
export default {"card":"Card_card__fmelL","vertical":"Card_vertical__r2ewj","left":"Card_left__Xe+fs","calicomp__texto":"Card_calicomp__texto__KnfO8","right":"Card_right__vhz6Q"};